import React from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import useFetchData from "../../../form/hooks/use-fetch-data.js";

const CharacteristicsFilter = ({filter, onChange, onChangeCustom}) => {
    const {
        bodyShape,
        colorEyes,
        hairType,
        hairColor,
        individualColors,
        region,
        regionDetail
    } = useFetchData()

    return (
        <SentryRow>
            <div className="col-span-3">
                <InputForm
                    id="height_max"
                    label="Altura máx. (cm)"
                    value={filter.height_max}
                    onChange={onChange}
                    type="number"
                />
            </div>
            <div className="col-span-3">
                <InputForm
                    id="height_min"
                    label="Altura mín. (cm)"
                    value={filter.height_min}
                    onChange={onChange}
                    type="number"
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="color"
                    value={filter.color}
                    options={individualColors}
                    label="Cútis"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "color")}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="bodyShape"
                    value={filter.bodyShape}
                    options={bodyShape}
                    label="Compleição"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "bodyShape")}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="eyes"
                    value={filter.eyes}
                    options={colorEyes}
                    label="Cor dos olhos"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "eyes")}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="hairType"
                    value={filter.hairType}
                    options={hairType}
                    label="Tipo dos cabelos"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "hairType")}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="hairColor"
                    value={filter.hairColor}
                    options={hairColor}
                    label="Cor dos cabelos"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "hairColor")}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="local"
                    value={filter.local}
                    options={region}
                    label="Local"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "local")}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="type"
                    value={filter.type}
                    options={regionDetail}
                    label="Tipo"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "type")}
                />
            </div>
            <div className="col-span-12">
                <InputForm
                    id="description"
                    value={filter.description}
                    label="Descrição"
                    onChange={onChange}
                />
            </div>
        </SentryRow>
    );
};

export default CharacteristicsFilter;
